import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Stealth gate for blocked users / banned devices.
 *
 * Business rule: a blocked person must NOT learn they were blocked. From any
 * device or link they simply see a generic "page not found" screen that looks
 * like the site does not exist. Triggered by:
 *   • /session/ban-status on mount (device fingerprint / IP banned), or
 *   • the axios interceptor when an /api call answers 403 with banned:true
 *     (blocked account trying to log in or using an old token).
 */
export const BannedGate = () => {
  const [ban, setBan] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const r = await axios.get(`${API}/session/ban-status`);
        if (!cancelled && r.data?.banned) setBan(r.data);
      } catch { /* interceptor covers the rest */ }
    };
    check();
    const handler = (ev) => setBan(ev.detail || { banned: true });
    window.addEventListener("ca:device-banned", handler);
    return () => { cancelled = true; window.removeEventListener("ca:device-banned", handler); };
  }, []);

  useEffect(() => {
    if (!ban) return;
    try {
      localStorage.removeItem("ca_token");
      document.title = "404 Not Found";
    } catch { /* ignore */ }
  }, [ban]);

  if (!ban) return null;

  return (
    <div
      data-testid="banned-gate"
      className="fixed inset-0 z-[9999] bg-white text-black flex flex-col items-center justify-center px-6"
      style={{ fontFamily: "Times New Roman, Times, serif" }}
    >
      <h1 className="text-2xl font-bold mb-3">404 Not Found</h1>
      <hr className="w-full max-w-lg border-neutral-300 mb-3" />
      <p className="text-sm text-neutral-600 mb-1">The page you are looking for does not exist or has been removed.</p>
      <p className="text-xs text-neutral-500 italic">nginx</p>
    </div>
  );
};

export default BannedGate;
